module.exports = __webpack_public_path__ + "img/graph_5.e71c3d4b.svg";